// @flow
import * as React from "react";

import { UserOutlined } from "@ant-design/icons";
import { Form, Input } from "antd";

const RULES = [
  {
    required: true,
    message: "Please enter your email",
  },
];

function EmailField(): React.Node {
  return (
    <Form.Item name="email" rules={RULES}>
      <Input type="email" prefix={<UserOutlined />} placeholder="Email" size="large" />
    </Form.Item>
  );
}

export default EmailField;
